import Swal from 'sweetalert2';
import { HTTP_CODES } from '../enums/httpCodes.enum';
import { MENSAJE } from '../constants/mensajes.constant';

export class MessageUtil {
    public static showSuccess(message: string, title?: string, callback?: any): void {
        if (title) {
            Swal.fire({
                icon: 'success',
                title: title,
                text: message,
                confirmButtonText: 'Cerrar',
                confirmButtonColor: '#3085d6',
            }).then(_ => { if (callback) callback(); });
        } else {
            Swal.fire({
                icon: 'success',
                title: message,
                confirmButtonText: 'Cerrar',
                confirmButtonColor: '#3085d6',
            }).then(_ => { if (callback) callback(); });
        }
    }

    public static showWarning(message: string, callback?: any): void {
        Swal.fire({
            icon: 'warning',
            title: message,
            confirmButtonText: 'Cerrar',
            confirmButtonColor: '#3085d6',
        }).then(_ => { if (callback) callback(); });
    }

    public static showError(error?: any, callback?: any): void {
        if(!error || error.status === HTTP_CODES.UnknownError){
            Swal.fire({
                icon: 'error',
                title: 'Lo sentimos',
                text: MENSAJE.ERROR,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Cerrar'
            }).then(_ => { if (callback) callback(); });
            return;
        }

        if (error.status === HTTP_CODES.BadRequest) {
            Swal.fire({
                icon: 'warning',
                title: 'Atención!',
                text: error.detail,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Cerrar'
            }).then(_ => { if (callback) callback(); });
        } else if (error.status === HTTP_CODES.InternalServerError) {
            Swal.fire({
                icon: 'error',
                title: 'Lo sentimos',
                text: MENSAJE.ERROR,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Cerrar'
            }).then(_ => { if (callback) callback(); });
        }
    }

    public static askQuestion(question: string, acceptText: string = 'Aceptar', cancelText: string = 'Cancelar') {
        return Swal.fire({
            icon: 'question',
            title: question,
            showCancelButton: true,
            confirmButtonText: acceptText,
            cancelButtonText: cancelText,
            confirmButtonColor: '#3085d6',
        })
    }
}
